export const SET_ACTIVE_JOB_TYPE = "SET_ACTIVE_JOB_TYPE";
export const SET_JOB_STATUS = "SET_JOB_STATUS";
export const GET_ALL_JOBS = "GET_ALL_JOBS";
export const GETTING_ALL_JOBS = "GETTING_ALL_JOBS";
export const SET_ALL_JOBS = "SET_ALL_JOBS";
export const GET_ALL_JOBS_ERROR = "GET_ALL_JOBS_ERROR";

export const UPDATE_JOB = "UPDATE_JOB";
export const UPDATE_JOB_SUCCESS = "UPDATE_JOB_SUCCESS";

export const SET_NOTIFICATION_JOB = "SET_NOTIFICATION_JOB";

export const ADD_EVIDENCE_JOB = "ADD_EVIDENCE_JOB";
export const ADD_EVIDENCE_JOB1 = "ADD_EVIDENCE_JOB1";
export const ADD_EVIDENCE_JOB_ERROR = "ADD_EVIDENCE_JOB_ERROR";
export const ADD_EVIDENCE_JOB_SUCCESS = "ADD_EVIDENCE_JOB_SUCCESS";

export const GET_EVIDENCE_JOB = "GET_EVIDENCE_JOB";
export const GET_EVIDENCE_JOB_MIDDLEWARE = "GET_EVIDENCE_JOB_MIDDLEWARE";

export const LOADER = "LOADER";
export const LANGUAGE_CHANGES = "LANGUAGE_CHANGES"

export const GET_ACTIVE_FILL = "GET_ACTIVE_FILL";
export const SET_ACTIVE_FILL = "SET_ACTIVE_FILL"

export const GET_ACTIVE_RENT_ARRANGE = "GET_ACTIVE_RENT_ARRANGE";
export const SET_ACTIVE_RENT_ARRANGE = "SET_ACTIVE_RENT_ARRANGE"

export const ALL_CYLINDER = "ALL_CYLINDER"

export const JOB_DETAIL = "JOB_DETAIL"
export const SELECT_BORROWED_DATA = "SELECT_BORROWED_DATA"
export const DISPLAY_TABLE_CYLINDER = "DISPLAY_TABLE_CYLINDER"

export const CREATE_JOB = "CREATE_JOB"
export const SET_CREATE_JOB = "SET_CREATE_JOB"
export const SELECT_BUILDING_DATA = "SELECT_BUILDING_DATA"

export const SELECT_SENDER_DATA = "SELECT_SENDER_DATA"
export const SELECT_DEALER_DATA = "SELECT_DEALER_DATA"
export const SELECT_CONTRACTOR_DATA = "SELECT_CONTRACTOR_DATA"
export const SELECT_RECYCLE_FACTORY_DATA = "SELECT_RECYCLE_FACTORY_DATA"
export const SELECT_DISPOSE_CONTRACTOR_DATA = "SELECT_DISPOSE_CONTRACTOR_DATA"

export const SELECT_CYLINDER_DATA = "SELECT_CYLINDER_DATA"
export const SELECT_TRANSPORT_DATA = "SELECT_TRANSPORT_DATA"
export const TRANSPORT_DATA_LIST = "TRANSPORT_DATA_LIST"

export const PAYLOAD_DEALER = "PAYLOAD_DEALER"
export const PAYLOAD_CONTRACTOR = "PAYLOAD_CONTRACTOR"
export const PAYLOAD_RECYCLE_FACTORY = "PAYLOAD_RECYCLE_FACTORY"
export const PAYLOAD_TRANSPORT = "PAYLOAD_TRANSPORT"

export const FILL_TOOL = "FILL_TOOL"
export const RECOVERY_TOOL = "RECOVERY_TOOL"
export const REFRIGERATOR_EQUIP = "REFRIGERATOR_EQUIP"
export const RECOVERY_REFRIGERATOR_EQUIP = "RECOVERY_REFRIGERATOR_EQUIP"
export const FILL_CAR_AC = "FILL_CAR_AC"
export const RECOVERY_CAR_AC = "RECOVERY_CAR_AC"

export const MULTI_IMAGE = "MULTI_IMAGE"

export const RECOVERY_REF_CYLINDER = "RECOVERY_REF_CYLINDER"
export const SET_REF_INDEX = "SET_REF_INDEX"
export const SET_AC_INDEX = "SET_AC_INDEX"

export const CREATE_RECOVERY_AND_FILL_JOB = "CREATE_RECOVERY_AND_FILL_JOB"
export const GET_ALL_JOB_VIEW = "GET_ALL_JOB_VIEW"
export const GET_ALL_JOB_VIEW_DATA = "GET_ALL_JOB_VIEW_DATA"
export const SET_FILTERED_CONTRACTOR = "SET_FILTERED_CONTRACTOR"

export const UPDATE_CYLINDER_JOB = "UPDATE_CYLINDER_JOB"
export const JOB_UPDATE_PAYLOAD = "JOB_UPDATE_PAYLOAD"
export const FILL_RECOVERY_JOB_CREATE = "FILL_RECOVERY_JOB_CREATE"
export const RECYCLE_JOB_CREATE = "RECYCLE_JOB_CREATE"
export const GET_JOB_ID = "GET_JOB_ID"

export const GET_SINGLE_JOB = "GET_SINGLE_JOB"
export const SET_SINGLE_JOB = "SET_SINGLE_JOB"

export const GET_UPDATE_API_DATA = "GET_UPDATE_API_DATA";
export const UPDATE_FLAG = "UPDATE_FLAG";

export const DELETE_CYLINDER_EQUIPMENT = "DELETE_CYLINDER_EQUIPMENT";

export const RESET_JOB_INIT_STATE = "RESET_JOB_INIT_STATE";

export const RENTAL_EDIT_FLAG = "RENTAL_EDIT_FLAG";
export const EDIT_RENTAL_JOB = "EDIT_RENTAL_JOB";

export const RENTAL_STATUS = "RENTAL_STATUS";
export const SELECT_RECEIVER_DATA = "SELECT_RECEIVER_DATA";
export const EDIT_INFO = "EDIT_INFO";

export const ADD_RECYCLE_JOB = "ADD_RECYCLE_JOB";
export const ADD_COMPLETE_RECYCLE_JOB = "ADD_COMPLETE_RECYCLE_JOB";
export const QR_SEARCH_CYLINDER_VALIDATION = "QR_SEARCH_CYLINDER_VALIDATION";
export const SET_QR_CYLINDER_VALIDATION = "SET_QR_CYLINDER_VALIDATION";
export const GET_QR_CYLINDER_DATA = "GET_QR_CYLINDER_DATA";
export const SET_QR_CYLINDER_DATA = "SET_QR_CYLINDER_DATA";
export const SET_SCANNER_TYPE = "SET_SCANNER_TYPE";

export const SET_DEFAULT_CAPACITY_VALUE = "SET_DEFAULT_CAPACITY_VALUE";
export const FILL_RECOVERY_INDEX = "FILL_RECOVERY_INDEX";

export const RECOVERY_CYLINDER_INDEX = "RECOVERY_CYLINDER_INDEX";
export const RECOVERY_CYLINDER_ARRAY = "RECOVERY_CYLINDER_ARRAY";

export const UPDATE_AWAITING_DATA = "UPDATE_AWAITING_DATA";
export const SET_QUICK_LINK_TYPE = "SET_QUICK_LINK_TYPE";
export const UPDATE_PROCESS_CERTIFICATE = "UPDATE_PROCESS_CERTIFICATE";
export const SET_CUSTOMER_BUILDING_UPDATE = "SET_CUSTOMER_BUILDING_UPDATE";
export const SEARCH_USER = "SEARCH_USER";
export const BUILDING_USER_SEARCH = "BUILDING_USER_SEARCH";
export const SET_SEARCH_USER = "SET_SEARCH_USER";

export const RECOVERY_CAR_AC_CYLINDER = "RECOVERY_CAR_AC_CYLINDER";
export const SET_OWNED_BORROWED_CYLINDER = "SET_OWNED_BORROWED_CYLINDER";
export const SET_MULTI_SELECTED_CYLINDER = "SET_MULTI_SELECTED_CYLINDER";
export const SET_100KG_TRANSFER_CYLINDER = "SET_100KG_TRANSFER_CYLINDER";
export const UPDATE_PROCESS_JOB = "UPDATE_PROCESS_JOB";
export const ADD_REVIEW = "ADD_REVIEW";
export const GET_REVIEW = "GET_REVIEW";

export const CUSTOMER_ID = "CUSTOMER_ID";
export const BUILDING_ID = "BUILDING_ID";

export const SET_REVIEW = "SET_REVIEW";

export const TRANSPORT_SEND_RETURN = "TRANSPORT_SEND_RETURN";
export const UPDATE_REFRIGERANT_VOLUME = "UPDATE_REFRIGERANT_VOLUME";
export const UPDATE_JOB_COMPLETE = "UPDATE_JOB_COMPLETE";
export const RESET_JOB_ACTION = "RESET_JOB_ACTION";

export const SET_FILL_RECOVERY_TYPE = "SET_FILL_RECOVERY_TYPE";
export const BRAND_PRODUCT_MODEL_DETAILS = "BRAND_PRODUCT_MODEL_DETAILS";
export const BRAND_OPTIONS_LIST = "BRAND_OPTIONS_LIST";
export const SET_EQUIPMENT_DETAIL_FLAG = "SET_EQUIPMENT_DETAIL_FLAG";
export const SET_UPDATED_JOB_EQUIPMENT_DETAIL = "SET_UPDATED_JOB_EQUIPMENT_DETAIL";
export const SEARCH_MY_JOBS = "SEARCH_MY_JOBS";
export const SEARCH_MY_JOBS_data = "SEARCH_MY_JOBS_data";
export const LOADER_FLAG = "LOADER_FLAG";
export const MULTI_DEALER_ADD = "MULTI_DEALER_ADD";
export const ALL_RESET_JOB_ACTION = "ALL_RESET_JOB_ACTION";
export const SHARE_CERTIFICATE = "SHARE_CERTIFICATE";
export const JOB_REVERT = "JOB_REVERT";
export const RENTAL_JOB_TYPE = "RENTAL_JOB_TYPE";
export const SHOW_LIST_FLAG = "SHOW_LIST_FLAG";
export const CONFIRMATION_EDIT_FLAG = "CONFIRMATION_EDIT_FLAG";
export const SET_RECEPTION_CYLINDER_DATA = "SET_RECEPTION_CYLINDER_DATA";
export const UPDATE_HISTORY = "UPDATE_HISTORY";
export const SET_UPDATE_HISTORY = "SET_UPDATE_HISTORY";
export const SET_MESSAGE_DATA = "SET_MESSAGE_DATA";
export const JOB_FLAG = "JOB_FLAG";
export const DEALER_JOB_FLAG = "DEALER_JOB_FLAG";
export const SET_QR_RESULT_DATA = "SET_QR_RESULT_DATA";
export const SET_JOB_READ = "SET_JOB_READ";
export const GET_CONFIRMATION_REPORT = "GET_CONFIRMATION_REPORT";
export const SET_CONFIRMATION_REPORT = "SET_CONFIRMATION_REPORT";
export const SEARCH_QR_JOBS = "SEARCH_QR_JOBS";
export const FISCAL_YEAR_LIST = "FISCAL_YEAR_LIST";
export const SET_FISCAL_YEAR_LIST = "SET_FISCAL_YEAR_LIST";
export const SET_JOB_SEARCH_VALUE = "SET_JOB_SEARCH_VALUE";
export const UPDATE_RENT_RETURN = "UPDATE_RENT_RETURN";
export const SET_RECOVERY_JOB_SCANNER_RES = "SET_RECOVERY_JOB_SCANNER_RES";
export const ISSUE_DETAILS = "ISSUE_DETAILS";
export const SET_LOT_LIST = "SET_LOT_LIST";
export const FILL_OTHER_CYLINDER = "FILL_OTHER_CYLINDER";
export const FILL_AC_CYLINDER = "FILL_AC_CYLINDER";
export const FILL_REF_CYLINDER = "FILL_REF_CYLINDER";

